"use client";

import Card from "../Card/Card";
import styles from "./FeaturesSection.module.scss";

const FeaturesSection = () => {
  const features = [
    {
      icon: "/ai.svg",
      title: "Intelligent Product Discovery",
      description:
        "AI agents that understand customer preferences and recommend products with unprecedented accuracy",
    },
    {
      icon: "/brain.svg",
      title: "Autonomous Shopping Assistance",
      description:
        "24/7 AI assistants that guide customers through their entire shopping journey",
    },
    {
      icon: "/circles.svg",
      title: "Personalized Experiences",
      description:
        "Dynamic content adaptation based on real-time customer behavior and preferences",
    },
    {
      icon: "/current.svg",
      title: "Instant Decision Making",
      description:
        "Lightning-fast AI processing for real-time pricing, inventory, and recommendation updates",
    },
  ];
  return (
    <section id="features" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.tag}>
            <span>Powerful Features</span>
          </div>
          {/* <Badge className={styles.badge}>Powerful Features</Badge> */}
          <h2 className={styles.title}>AI Shopping Assistant Capabilities</h2>
          <p className={styles.subtitle}>
            Our intelligent agents work tirelessly to understand your customers
            and optimize their shopping experience.
          </p>
        </div>

        <div className={styles.grid}>
          {features?.map((feature, index) => (
            <Card
              key={index}
              //   className={styles.card}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
